import React from 'react';
import { Table as MaterialTable, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  table: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    '& thead th': {
      textAlign: 'center',
    },
    '& th': {
      backgroundColor: '#f8f8f8',
      // textAlign: 'center',
      fontWeight: 600,
      '& span': {
        color: 'red',
      },
    },
  },
});

class Table extends React.Component {
  render() {
    const { classes } = this.props;
    return <MaterialTable className={classes.table}>{this.props.children}</MaterialTable>;
  }
}

export default withStyles(styles, { withTheme: true })(Table);
